"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignOwner = exports.patchRegistry = exports.deleteInstallationAddress = exports.putInstallationAddress = exports.patchMetadata = exports.putContactInfo = exports.patchLoyaltyPrograms = exports.getInstallationStatusHistory = exports.getConnectionHistory = exports.getLogLevel = exports.getTenantAssociations = exports.getRegistry = exports.getOperatingModeAndPowerProfile = exports.getSwVersion = exports.getDevicesByMsns = exports.getDeviceByMsn = exports.listRegistry = exports.getDevices = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../../../device"));
const openapi_1 = require("../../../../../../openapi");
const Schema = __importStar(require("./schema"));
const MALFORMED_JSON = 'Malformed JSON is the Express default HTML 400: express.json() is attached on the route, ' +
    'and the JSON error handler runs before the routes.';
const Empty = openapi_1.Response.EmptyData.annotations({
    description: 'v1 success with data: {}',
});
const deviceId = platform_1.HttpApiSchema.param('deviceId', Device.Class.Common.Id);
const installationDeviceId = platform_1.HttpApiSchema.param('deviceId', effect_1.Schema.String);
const v2Failure = 'A failure in the catch is the v2 500.';
const handlerUnauthorized = 'The handler answers 401 with the v2 not-authorized body.';
const anyDevice = "The handler does not check the caller's tenant, so any role this route allows can address any device.";
const roleSessionAnyDevice = 'A role session is not checked against the device tenant, so any role this route allows can address any device.';
exports.getDevices = platform_1.HttpApiEndpoint.get('listAdminDevices') ``
    .setUrlParams(Schema.DevicesQuery)
    .addSuccess(openapi_1.Response.Success(Schema.DevicePage))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'List devices')
    .annotate(platform_1.OpenApi.Description, 'Returns a page of encoded devices visible to the caller. The filter field is tenantIds. ' +
    'A single tenantIds value is a string, so it does not decode and is 400. ' +
    'pageSize above 100 does not decode and is 400. orderBy is id, model, status or swVersion. ' +
    'When orderBy is set, orderDir asc is ascending and desc is descending. Any other orderDir does not decode and is 400. An omitted orderDir is descending. ' +
    'status sorts by status.connection.online. A caller with no tenantId gets 200 and an empty page ' +
    '(page 1, itemsCount 0, pagesCount 1, items []). A tenant lookup failure is the v2 401. ' +
    'A query that does not decode is 400. A session, query or encoding failure is the v2 500. ' +
    handlerUnauthorized);
exports.listRegistry = platform_1.HttpApiEndpoint.get('listRegistry') `/registry/list`
    .setUrlParams(Schema.RegistryListQuery)
    .addSuccess(openapi_1.Response.Success(Schema.RegistryListPage))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'List registry devices')
    .annotate(platform_1.OpenApi.Description, 'Lists protocolVersion 2 devices through the legacy parser. The page is the v1 success body. ' +
    'items have errors and alarms removed, and each alarm severity is counted on status.alarms. ' +
    'page must be an integer of at least 1. pageSize must be from 1 to 100. size is validated as an integer of at least 1 and is then ignored: ' +
    'an omitted pageSize uses 50. orderBy is any string, and a comma-separated list sorts by each field. ' +
    'orderDir must be asc or desc, and an omitted direction with orderBy is ascending. ' +
    'When properties is present but swVersion or operatingMode is absent, that key is omitted. ' +
    'A parsed query that fails these rules is 422 INVALID_REQUEST with inputValidation. A query failure is the v1 500. There is no 404. ' +
    anyDevice);
exports.getDeviceByMsn = platform_1.HttpApiEndpoint.get('getDeviceByMsn') `/dsn`
    .setUrlParams(Schema.MsnQuery)
    .addSuccess(openapi_1.Response.Success(Device.Class.Common.Id))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.NotFound)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'Get device by manufacturing serial number')
    .annotate(platform_1.OpenApi.Description, 'Returns the device id for one manufacturingSerialNumber. data is that id. ' +
    'A query that does not decode is 400. No match is 404. When several devices match, the response is the first id. ' +
    'An id that does not encode, or a read failure, is the v2 500. ' +
    anyDevice);
exports.getDevicesByMsns = platform_1.HttpApiEndpoint.get('getDevicesByMsns') `/dsns`
    .setUrlParams(Schema.MsnsQuery)
    .addSuccess(openapi_1.Response.Success(Schema.MsnPairs))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'Get devices by manufacturing serial numbers')
    .annotate(platform_1.OpenApi.Description, 'Returns manufacturingSerialNumber and deviceSerialNumber for each match. The query field is manufacturingSerialNumbers. ' +
    'A match is a device whose manufacturingSerialNumber or state.msn is in the list. ' +
    'A query that does not decode is 400. A read failure is swallowed and the response is 200 with an empty list. ' +
    'That includes a result in which any matched document does not decode. There is no 404. ' +
    'A result that does not encode is the v2 500. ' +
    anyDevice);
exports.getSwVersion = platform_1.HttpApiEndpoint.get('getSwVersion') `/swVersion`
    .setUrlParams(Schema.ExpressSerialQuery)
    .addSuccess(openapi_1.Response.Success(Schema.SwVersion))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.NotFound)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get software version')
    .annotate(platform_1.OpenApi.Description, 'Returns the stored swVersion. A missing or empty serialNumber is 422 INVALID_REQUEST with inputValidation. ' +
    'A serial with no document is the v2 404, message "Device not found". A document whose swVersion is empty is the v1 404 NOT_FOUND. ' +
    'The CPort session check compares the constructor name with CPortSessionManager, which never matches, so it does not return 401. ' +
    anyDevice);
exports.getOperatingModeAndPowerProfile = platform_1.HttpApiEndpoint.get('getOperatingModeAndPowerProfile') `/operatingModeAndPowerProfile`
    .setUrlParams(Schema.ExpressSerialQuery)
    .addSuccess(openapi_1.Response.Success(Schema.OperatingModeAndPowerProfile))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get operating mode and power profile')
    .annotate(platform_1.OpenApi.Description, 'The path is operatingModeAndPowerProfile. A missing or empty serialNumber is 422 INVALID_REQUEST with inputValidation. ' +
    'The read selects properties.operatingMode and properties.powerProfile. Success requires a row whose operatingMode or powerProfile is truthy; ' +
    'either field is then null when it is empty. No such row is the v1 404 NOT_FOUND. There is no v2 404. ' +
    'The CPort session check compares the constructor name with CPortSessionManager, which never matches, so it does not return 401. ' +
    'A query that throws is the v1 500. ' +
    anyDevice);
exports.getRegistry = platform_1.HttpApiEndpoint.get('getRegistry') `/registry`
    .setUrlParams(Schema.RegistryQuery)
    .addSuccess(openapi_1.Response.Success(Schema.RegistryDevice))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.NotFound)
    .addError(openapi_1.Error.Internal)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get registry device')
    .annotate(platform_1.OpenApi.Description, 'Returns one device. An absent domainOutput, an empty string, or the string false selects the legacy device. Any other value selects the domain device. ' +
    'On the domain path, a caller who is not using SAT and has no tenantId gets 200 and data: null. ' +
    "A SAT that does not list this device is the v2 401, on both paths. The domain path also returns the v2 401 when the device tenant is outside the caller's tenants; the root tenant is allowed. " +
    "The legacy path does not check the caller's tenant, so any role this route allows can read any device. " +
    'On the domain path, session.getUser() runs before the handler catch. If it throws, the route answers the v1 500. ' +
    'A serial that does not decode is 400. On the legacy path that 400 puts the parse error itself in issues, not the formatted issue list. ' +
    'A missing device is 404. A legacy document that does not decode is 400 with formatted issues. A domain document that does not decode is the v2 500. ' +
    'ThinkWater, code thn, is not in the legacy vendor list. Reading vendor.Code then throws and the legacy path answers the v2 500. The same throw happens for any other code that list does not contain. ' +
    handlerUnauthorized);
exports.getTenantAssociations = platform_1.HttpApiEndpoint.get('getTenantAssociations') `/registry/tenant-associations`
    .setUrlParams(Schema.SerialNumberQuery)
    .addSuccess(openapi_1.Response.Success(Schema.TenantAssociations))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.NotFound)
    .addError(openapi_1.Error.Internal)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get tenant associations')
    .annotate(platform_1.OpenApi.Description, 'Returns the associations of the device tenant. A caller who is not using SAT and has no tenantId gets 200 and tenantAssociations: []. ' +
    'A tenant that cannot be loaded is logged and also returns 200 with an empty list. ' +
    "A SAT that does not list this device, or a device outside the caller's tenants, is the v2 401. The root tenant is allowed. " +
    'session.getUser() runs before the handler catch. If it throws, the route answers the v1 500. ' +
    'A serial that does not decode is 400. A missing device is 404. A document that does not decode is the v2 500. ' +
    'Each association is returned with only the fields that are set. ' +
    handlerUnauthorized);
exports.getLogLevel = platform_1.HttpApiEndpoint.get('getLogLevel') `/log-level`
    .setUrlParams(Schema.ExpressSerialQuery)
    .addSuccess(openapi_1.Response.Success(Schema.LogLevel))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get log level')
    .annotate(platform_1.OpenApi.Description, 'Returns properties.logLevel when it is truthy. A missing or empty serialNumber is 422 INVALID_REQUEST with inputValidation. ' +
    'No row, or an empty logLevel, is the v1 404 NOT_FOUND. There is no v2 404. ' +
    'The CPort session check compares the constructor name with CPortSessionManager, which never matches, so it does not return 401. ' +
    'A query that throws is the v1 500. ' +
    anyDevice);
exports.getConnectionHistory = platform_1.HttpApiEndpoint.get('getConnectionHistory') `/${deviceId}/connection-history`
    .setUrlParams(Schema.ConnectionHistoryQuery)
    .addSuccess(openapi_1.Response.Success(Schema.ConnectionHistoryPage))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'Get connection history')
    .annotate(platform_1.OpenApi.Description, 'Returns encoded connection events for deviceId, newest first, with createdAt from connectionStart through connectionEnd. ' +
    'Both bounds are required numeric strings. A query or a deviceId that does not decode is 400. ' +
    'A SAT that does not list this device is the v2 401. A device that does not exist is 200 with items: []. There is no 404. ' +
    `${roleSessionAnyDevice} ${v2Failure} ${handlerUnauthorized}`);
exports.getInstallationStatusHistory = platform_1.HttpApiEndpoint.get('getInstallationStatusHistory') `/${installationDeviceId}/installation-status-history`
    .setUrlParams(Schema.InstallationHistoryQuery)
    .addSuccess(openapi_1.Response.Success(Schema.InstallationHistoryPage))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.Internal)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get installation status history')
    .annotate(platform_1.OpenApi.Description, 'Returns installation-status history for deviceId, newest first. deviceId is any string; it is not checked as a device id. ' +
    'from and to are optional numeric strings. A value of 0 is decoded and then ignored. A bound that is set filters createdAt. ' +
    'A number that decodes but is not a valid date, such as 1e20, makes toISOString throw. That throw is outside the query catch, so the route answers the v1 500. ' +
    'A query that does not decode is 400. A SAT that does not list this device is the v2 401. ' +
    'A device that does not exist is 200 with items: []. There is no 404. The handler returns the stored rows. ' +
    `${roleSessionAnyDevice} ${v2Failure} ${handlerUnauthorized}`);
exports.patchLoyaltyPrograms = platform_1.HttpApiEndpoint.patch('patchLoyaltyPrograms') `/registry/loyalty-programs`
    .setUrlParams(Schema.UncheckedSerialQuery)
    .setPayload(Schema.LoyaltyProgramsBody)
    .addSuccess(openapi_1.Response.Success(Schema.LoyaltyUpdate))
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Update loyalty programs')
    .annotate(platform_1.OpenApi.Description, 'Replaces the device loyalty programs. Success is the v1 body with data: { success: true }. ' +
    'loyaltyPrograms must be an array. When it is missing, reading its length throws before validation and the route answers the v1 500. ' +
    'A parsed body that is not an array, or an item that is empty when the array is not, is 422 INVALID_REQUEST with inputValidation. ' +
    'serialNumber is not validated. A value that loads no device is 404 and the message is "Device not found", not NOT_FOUND. ' +
    'An unknown program id is 404 and the message is "Loyalty program <id> not found". ' +
    'An update that does not report a result is 404 and the message is "Loyalty programs not found". ' +
    'The CPort session check compares the constructor name with CPortSessionManager, which never matches, so it does not return 401. ' +
    'A thrown update is 500 and the message is the thrown text, not EXECUTION_FAILED. ' +
    `${anyDevice} ${MALFORMED_JSON}`);
exports.putContactInfo = platform_1.HttpApiEndpoint.put('putContactInfo') `/contact-info`
    .setUrlParams(Schema.SerialNumberQuery)
    .setPayload(Device.Class.Base.ContactInfo)
    .addSuccess(openapi_1.Response.Success(Device.Class.Device))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.NotFound)
    .addError(openapi_1.Error.Internal)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Update contact info')
    .annotate(platform_1.OpenApi.Description, 'Replaces contactInfo and returns the encoded device. The session is ignored. ' +
    'A serialNumber that does not decode is 400, message "Invalid request query parameters". ' +
    'A body that parses but does not decode is 400, message "Invalid request body". ' +
    'A missing device is 404. An update or encoding failure is the v2 500. ' +
    'A database error from the device read throws before that result is handled, so the route answers the v1 500. ' +
    `${anyDevice} ${MALFORMED_JSON}`);
exports.patchMetadata = platform_1.HttpApiEndpoint.patch('patchMetadata') `/registry/metadata`
    .setUrlParams(Schema.UncheckedSerialQuery)
    .setPayload(Schema.MetadataBody)
    .addSuccess(Empty)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthenticated)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Update metadata')
    .annotate(platform_1.OpenApi.Description, 'Stores metadata items for the device. This is the service-menu metadata handler. ' +
    'serialNumber is taken from the query when that key is present, including an empty value. The body is used only when the key is absent. ' +
    'The session is the raw device document. A database error during that load is the v1 500, before the handler runs. ' +
    'A missing document makes getDevice() throw NOT_ALLOWED, and this handler answers 401. ' +
    'items must be a non-empty array. Each item needs a non-empty string key. value may be any JSON value, and a missing value is 422. ' +
    'A parsed body that fails these rules is 422 INVALID_REQUEST with inputValidation. Success is data: {}. ' +
    'A failed write is the v1 500. ' +
    `${anyDevice} ${MALFORMED_JSON}`);
exports.putInstallationAddress = platform_1.HttpApiEndpoint.put('putRegistryInstallationAddress') `/registry/installation-address`
    .setUrlParams(Schema.SerialNumberQuery)
    .setPayload(Schema.InstallationAddressBody)
    .addSuccess(openapi_1.Response.Success(Device.Class.Device))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.NotFound)
    .addError(openapi_1.Error.Internal)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Replace installation address')
    .annotate(platform_1.OpenApi.Description, 'Replaces installationAddress and returns the encoded device. The session is passed through and is not used to check the tenant. ' +
    'A serialNumber that does not decode is 400, message "Invalid request query parameters". ' +
    'A body that parses but does not decode is 400, message "Invalid request body". ' +
    'A missing device is 404. A document that does not decode is the v2 500, message "Invalid device data". ' +
    'When providedLocation is omitted, the address is geocoded. A geocode result that is not a numeric lat and lon is stored as null. ' +
    'A database error from the device read, and a geocode call that throws, are outside the handler catch, so the route answers the v1 500. ' +
    'A save or encoding failure is the v2 500. ' +
    `${anyDevice} ${MALFORMED_JSON}`);
exports.deleteInstallationAddress = platform_1.HttpApiEndpoint.del('deleteRegistryInstallationAddress') `/registry/installation-address`
    .setUrlParams(Schema.SerialNumberQuery)
    .addSuccess(openapi_1.Response.Success(Device.Class.Device))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.NotFound)
    .addError(openapi_1.Error.Internal)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Delete installation address')
    .annotate(platform_1.OpenApi.Description, 'Clears installationAddress and providedLocation and returns the encoded device. The session is passed through and is not used to check the tenant. ' +
    'A serialNumber that does not decode is reported as a bad body: 400, message "Invalid request body". ' +
    'A missing device is 404. A document that does not decode is the v2 500, message "Invalid device data". ' +
    'A database error from the device read throws before that result is handled, so the route answers the v1 500. ' +
    `A save or encoding failure is the v2 500. ${anyDevice}`);
exports.patchRegistry = platform_1.HttpApiEndpoint.patch('patchRegistry') `/registry/${deviceId}`
    .setPayload(Schema.DevicePatch)
    .addSuccess(openapi_1.Response.Success(Device.Class.Device))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.NotFound)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'Patch registry device')
    .annotate(platform_1.OpenApi.Description, 'Patches an existing device and returns the encoded device. The session is ignored, so an admin can patch any device. This does not create a device. ' +
    'A deviceId that does not decode is 400, message "Invalid path parameters". ' +
    'A body that parses but does not decode, including an unknown field, is 400, message "Invalid request body". ' +
    'A patch that decodes but does not make a valid device is the same 400. ' +
    'ownerId is removed before that decode. When the submitted ownerId differs from the stored one, the response is still 400 ' +
    '"Invalid request body", with an issue on ownerId, and nothing is written. The same ownerId is ignored. ' +
    'When installationAddress.address changes and providedLocation is absent, the address is geocoded into providedLocation. ' +
    'A failed lookup keeps the stored location. An empty address sets providedLocation to null. ' +
    'A missing device is 404. A read, write or encoding failure is the v2 500. ' +
    MALFORMED_JSON);
exports.assignOwner = platform_1.HttpApiEndpoint.put('assignOwner') `/registry/${deviceId}/owner`
    .setPayload(Schema.AssignOwnerBody)
    .addSuccess(openapi_1.Response.Success(Schema.AssignOwnerResult))
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.NotFound)
    .addError(openapi_1.Error.Conflict)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'Assign device owner')
    .annotate(platform_1.OpenApi.Description, 'Sets the device owner and returns changed plus the encoded device. changed is false, and nothing is written, when the device is already owned by userId. ' +
    'A deviceId that does not decode is 400, message "Invalid path parameters". ' +
    'A body that parses but does not decode, including an unknown field, is 400, message "Invalid request body". expectedCurrentOwnerId is required and may be null. ' +
    'A caller with no tenantId, or whose tenant document is missing, is the v2 401, message "Caller has no tenant". ' +
    'A device outside the caller\'s tenants is 404, message "Device not found". ' +
    'A target user that does not exist or sits outside the caller\'s tenants is 404, message "Target user is not available for assignment". A target with no tenant is allowed. ' +
    'When the stored owner is not expectedCurrentOwnerId, the response is 409. ' +
    "A changed assignment strips the device's rules before the write. When the device has ever had an ownerId, registeredAt or deregisteredAt, the same write clears dealer, detectedLocation, providedLocation, installationAddress and contactInfo, sets installationStatus to Factory, sets installedAt to null and sets installationUpdatedAt. " +
    'A device that does not exist is 404, message "Device <id> not found.". ' +
    'A read, write or encoding failure is the v2 500. ' +
    `${handlerUnauthorized} ${MALFORMED_JSON}`);
//# sourceMappingURL=endpoints.js.map